
import { learningObjectivesIntro, activitiesListIntro, initialPost, standardActivities, standardActivitiesClosing, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'
import { typesOfSoftwareLicenses, choosingASoftwareLicense, addGitHubSoftwareLicense } from '../DataAndAPIs/Links'
import { lionsTigersAndBearsLink } from '../Activities/LionsTigerAndBears'
import { externalLink, oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { chapter13Lecture } from '../ActivityVideo/ActivityArchitecture'
import { webDiceRollerLink } from '../Activities/WebDiceRoller'
import { assignmentPortfolioWithNodeJSLink } from '../Activities/WebAssignmentPortfolioWithNodeJS'


export const al61200Sprint03 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		<p>Now that we have a good understanding of the broader meaning of software architecture and the characteristics 
		of high-quality ones, it is the time to dive deeper and learn about some of the most common architectural 
		tactics and styles. These architectural styles, which have been developed and refined over the past few decades 
		by practitioners and accepted by the software engineering community represent high quality and proven solutions 
		to recurring architectural problems. Model-View-Controller, Layered Architecture, Client-Server, Peer to Peer 
		Architecture, <em>Service-Oriented-Architectures (SOA)</em>, and many more will be discussed in detail.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>List and explain major Architectural styles and tactics</li>
			<li>Recognize problems where various styles can be applied including MVC, client-server, peer-to-peer, and SOA</li>
			<li>Use the most appropriate architectural style for a problem</li>
			<li>Realize and implement a simple software using SOA with MERN on Azure</li>
		</ul>

		{list61200Sprint03(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint03 = (sprint) => {
	const react = () => { return externalLink('React', 'https://react.dev/')}
	const reactQuickStart = () => { return externalLink('React Quick Start', 'https://react.dev/learn')}
	const nodeJSW3CTutorial = () => { return externalLink('Node.js Tutorial', 'https://www.w3schools.com/nodejs/') }

	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, assignmentPortfolioWithNodeJSLink(), oreillyPlaylistSA(), false)}
			<li>Review {typesOfSoftwareLicenses()}, {choosingASoftwareLicense()}, and {addGitHubSoftwareLicense()}</li>
			<li>Complete {webDiceRollerLink()}</li>
			<li>Complete {lionsTigersAndBearsLink()}</li>
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 13” and watch the associated {chapter13Lecture()}</li>
			<li>Review {react()} and complete {reactQuickStart()} </li>

			{initialPost(sprint)}
			<li>Rewrite {lionsTigersAndBearsLink()} as an Azure hosted React application</li>
			<li>Complete the W3C {nodeJSW3CTutorial()}</li>
			{standardActivitiesClosing(sprint, assignmentPortfolioWithNodeJSLink(), '5 hours')}
		</ol>
	</div> )
}
